import { Box, Flex, Text, Image, Input } from "@chakra-ui/react";
import I1Icon from "./assets/i1.png";
import BottomButton from "@/components/Button/BottomButton";
import B1Icon from "./assets/b1.png";
import { useUserInfo } from "@/context/UserInfo";

const FillInfo = ({
  errorMessage,
  firstName,
  lastName,
  email,
  onFirstName,
  onLastName,
  onEmail,
  onConfirm,
  leageName,
  onLeageName,
  type,
  onResetErrorMessage,
}: {
  errorMessage: string;
  firstName: string;
  lastName: string;
  email: string;
  type: string;
  onFirstName: (value: string) => void;
  onLastName: (value: string) => void;
  onEmail: (value: string) => void;
  onConfirm: () => void;
  canConfirm: boolean;
  leageName: string;
  onLeageName: (value: string) => void;
  onResetErrorMessage: () => void;
}) => {
  const { bridgeCustomer } = useUserInfo();
  return (
    <Box>
      <Text
        sx={{
          color: "#848484",
          fontFamily: "DIN",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          marginTop: "30px",
        }}
      >
        Complete verification to enable withdrawal to bank account.
      </Text>
      <Box
        sx={{
          marginTop: "20px",
        }}
      >
        <Text
          sx={{
            color: "#333",
            fontSize: "20px",
            fontWeight: 700,
          }}
        >
          Type
        </Text>
        <Flex
          sx={{
            marginTop: "15px",
          }}
          alignItems="center"
        >
          <Image
            src={type === "individual" ? I1Icon : B1Icon}
            sx={{
              width: "30px",
              height: "30px",
              marginRight: "10px",
            }}
          ></Image>
          <Text sx={{ fontSize: "16px", fontWeight: 500 }}>
            {type === "individual" ? "Individual" : "Business"}
          </Text>
        </Flex>
      </Box>
      <Box>
        {type === "business" ? (
          <>
            <Text
              sx={{
                marginTop: "15px",
              }}
            >
              Legal Business Name
            </Text>
            <Input
              variant="unstyled"
              sx={{
                marginTop: "10px",
                _placeholder: {
                  color: "#DEDEDE",
                  fontSize: "14px",
                },
              }}
              placeholder="Business name"
              value={leageName}
              onChange={(e) => {
                onLeageName(e.target.value);
              }}
            ></Input>
          </>
        ) : (
          <>
            {" "}
            <Text
              sx={{
                marginTop: "15px",
              }}
            >
              First Name
            </Text>
            <Input
              variant="unstyled"
              sx={{
                marginTop: "10px",
                _placeholder: {
                  color: "#DEDEDE",
                  fontSize: "14px",
                },
              }}
              placeholder="My First Name"
              value={firstName}
              onChange={(e) => {
                onFirstName(e.target.value);
              }}
            ></Input>
            <Text
              sx={{
                marginTop: "15px",
              }}
            >
              Last Name
            </Text>
            <Input
              variant="unstyled"
              sx={{
                marginTop: "10px",
                _placeholder: {
                  color: "#DEDEDE",
                  fontSize: "14px",
                },
              }}
              placeholder="My Last Name"
              value={lastName}
              onChange={(e) => {
                onLastName(e.target.value);
              }}
            ></Input>
          </>
        )}

        <Text
          sx={{
            marginTop: "15px",
          }}
        >
          Email Address
        </Text>
        <Input
          variant="unstyled"
          sx={{
            marginTop: "10px",
            _placeholder: {
              color: "#DEDEDE",
              fontSize: "14px",
            },
          }}
          value={bridgeCustomer?.email}
          disabled={true}
          placeholder="My Email"
        ></Input>
      </Box>
      <BottomButton
        onClick={onConfirm}
        errorMessage={errorMessage}
        onCloseError={onResetErrorMessage}
      >
        Next
      </BottomButton>
    </Box>
  );
};

export default FillInfo;
